/**
 * PartnerType: Defines how a partner onboards customers.
 *
 * Used in:
 * - Partner.type: Determines partner classification
 *
 * Values:
 * - WHITE_LABEL: Partner has their own branded domain (e.g., waba.growwsaas.com)
 * - AFFILIATE: Partner refers customers who sign up via app.heltar.com
 */
export enum PartnerType {
  WHITE_LABEL = 'WHITE_LABEL',
  AFFILIATE = 'AFFILIATE',
}

/**
 * PartnerStatus: Current state of a partner account.
 */
export enum PartnerStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
